// api.ts
import { FIREBASE_FUNCTION_URL } from './config';

export async function sendRequest(endpoint: string, data: any, method: 'POST' | 'GET' = 'POST') {
    const base = (FIREBASE_FUNCTION_URL || '').replace(/\/+$/, '');
    let url = `${base}/${endpoint}`;
    try {
        const host = new URL(base).host;
        // If using a Cloud Run service URL (a.run.app), the service often represents a single endpoint.
        // In that case, call the base directly without appending the endpoint.
        if (/\.a\.run\.app$/i.test(host)) {
            url = base;
        }
    } catch {
        // If URL parsing fails, fall back to default concatenation
    }
    const options: RequestInit = {
        method,
        headers: {
            'Content-Type': 'application/json'
        },
        body: method === 'POST' ? JSON.stringify(data) : undefined
    };

    const response = await fetch(url, options);
    if (!response.ok) {
        // Try to capture error payload for better diagnostics
        const contentType = response.headers.get('content-type') || '';
        let errorBody: any = null;
        try {
            errorBody = contentType.includes('application/json') ? await response.json() : await response.text();
        } catch {
            // ignore parse errors
        }
        const err: any = new Error(`Request failed: ${response.status}`);
        err.status = response.status;
        err.body = errorBody;
        err.url = url;
        throw err;
    }
    const contentType = response.headers.get('content-type') || '';
    if (contentType.includes('application/json')) {
        return response.json();
    }
    // Fallback to text for Firebase function plain text responses
    return response.text();
}